{
  "Clear search": "Zoekopdracht wissen"
}
